import { render, staticRenderFns } from "./commonPosition.vue?vue&type=template&id=dfe568cc&"
import script from "./commonPosition.vue?vue&type=script&lang=ts&"
export * from "./commonPosition.vue?vue&type=script&lang=ts&"
import style0 from "./commonPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports